// DEPENDENCIES
import React, { useEffect, useState } from 'react';
// COMPONENTS
import MUIDataTable from "mui-datatables";
// ICONS
// CUSTOM COMPONENTS
import FormBlock from '../../../../components/FormBlock';
import Section from '../../../../components/Section';
import ContentBlock from '../../../../components/ContentBlock';
import CustomBlock from '../../../../components/CustomBlock';
import ContentHeader from '../../../../components/ContentHeader';
import InputBlock from '../../../../components/InputBlock';
import TextAreBlock from '../../../../components/TextAreBlock';
import SelectBlock from '../../../../components/SelectBlock';
import CheckboxBlock from '../../../../components/CheckboxBlock';
import ModalBlock from '../../../../components/ModalBlock';
import Button from '../../../../components/Button';
// PARTIALS
import LBPSurveyDataSheet from './_partials/LBPSurveyDataSheet';
import LeadInWaterSurveryDataSheet from './_partials/LeadInWaterSurveryDataSheet';
import LeadWipeSurveyDataSheet from './_partials/LeadWipeSurveyDataSheet';
import TCLPSurveyDataSheet from './_partials/TCLPSurveyDataSheet';
import TCLPRCRA8SurveyDataSheet from './_partials/TCLPRCRA8SurveyDataSheet';
import ColiFormEColiSurveyDataSheet from './_partials/ColiFormEColiSurveyDataSheet';
import BacteriaSurveyDataSheet from './_partials/BacteriaSurveyDataSheet';
import MoldSurveyDataSheet from './_partials/MoldSurveyDataSheet';
import WaterSurveyDataSheet from './_partials/WaterSurveyDataSheet';
// SERVICES AND HELPERS

const SurveyDataSheetForm = (props) => {

    const [confirmDeleteModalVisible, setConfirmDeleteModalVisible] = useState(false);
    const [formName, setFormName] = useState('');

    const columnOptions = {
        filter: true,
        sort: true,
        print: false,
        download: true
    };

    const options = {
        selectableRows: "none",
        download: true,
        print: false,

    };

    const data = [
        ['', '1', '08/25/2021', 'Bulk', 'PCM', '10', 'test sample notes'],
        ['', '2', '08/25/2021', 'Air', 'TEM', '5', 'test sample notes'],
        ['', '3', '08/25/2021', 'Paint Chips', 'PLM', '0.2', 'test sample notes'],
    ];

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                print: false,
                download: false,
                customBodyRenderLite: () => {
                    return (
                        <CustomBlock className="content-container--actions flex-start pl-0 mt-0">
                            <Button
                                text="Edit"
                                className="info--bg ml-0"
                                size="xxs"
                                to="/job/po/material/edit/:0"
                            />

                            <Button
                                text="Delete"
                                className="danger--bg"
                                size="xxs"
                                onClick={() => setConfirmDeleteModalVisible(true)}
                            />
                        </CustomBlock>
                    )
                }
            }

        },
        {
            name: "sampleNumber",
            label: "Sample No.",
            options: columnOptions
        },
        {
            name: "date",
            label: "Date",
        },
        {
            name: "sampleType",
            label: "Sample Type",
        },
        {
            name: "test",
            label: "Test",
        },
        {
            name: "sampleVolume",
            label: "Sample Volume",
        },
        {
            name: "notes",
            label: "Notes",
        },
    ];

    return (
        <>
            <FormBlock>
                <Section>
                    <ContentBlock>
                        <CustomBlock className="content-container--card-style--with-shadow">
                            <ContentHeader
                                title={`${formName} Survey Data Sheet`}
                                headerSize="md"
                                primaryButtonText="Print Form"
                                primaryButtonBackgroundColor="info--bg mr-0"
                                // secondaryButtonText="Save Changes"
                                // secondaryButtonBackgroundColor="warning--bg"
                            />

                            <CustomBlock>
                                {/* HEADER SECTION */}
                                <Section removeContainer className="pb-10">
                                    <ContentBlock>
                                        <ContentHeader
                                            title="Header Information"
                                            headerSize="sm"
                                            className="fw-700 pb-10"
                                        />
                                    </ContentBlock>

                                    <ContentBlock cols={4}>
                                        <InputBlock
                                            label="Project No."
                                        />

                                    </ContentBlock>

                                    <ContentBlock cols={4}>
                                        <InputBlock
                                            label="Date"
                                        />
                                    </ContentBlock>

                                    <ContentBlock cols={4}>
                                        <InputBlock
                                            label="Inspector"
                                        />
                                    </ContentBlock>

                                    <ContentBlock cols={4}>
                                        <InputBlock
                                            label="Client"
                                        />
                                    </ContentBlock>

                                    <ContentBlock cols={8}>
                                        <InputBlock
                                            label="Project Location"
                                        />
                                    </ContentBlock>
                                </Section>

                                {/* LINE ITEM ENTRY SECTION */}
                                <LBPSurveyDataSheet />
                                <LeadInWaterSurveryDataSheet />
                                <LeadWipeSurveyDataSheet />
                                <TCLPSurveyDataSheet />
                                <TCLPRCRA8SurveyDataSheet />
                                <ColiFormEColiSurveyDataSheet />
                                <BacteriaSurveyDataSheet />
                                <MoldSurveyDataSheet />
                                <WaterSurveyDataSheet />
                                
                                {/* ACTIONS */}
                                <Section removeContainer className="pt-10">
                                    <ContentBlock className="content-container--actions">
                                        <Button
                                            text="Save Changes"
                                            className="warning--bg"
                                        />
                                        <Button
                                            text="Submit Form"
                                            className="success--bg"
                                        />
                                    </ContentBlock>
                                </Section>
                            </CustomBlock>
                        </CustomBlock>
                    </ContentBlock>
                </Section>
            </FormBlock>

            {/* CONFIRM DELETE MODAL */}
            <ModalBlock
                show={confirmDeleteModalVisible}
                contentHeader="Delete Line Item"
                onHide={() => setConfirmDeleteModalVisible(false)}
                closeAction
                centered
                contentDescription="Are you sure you want to delete this line item?"
                primaryModalActionOnClick={() => console.log("Deleting...")}
            />
        </>
    )
}

export default SurveyDataSheetForm;